import {Reducer} from 'redux'
import {DraftsPeopleActionTypes} from "@actions/draftPeople";
import {DraftPeopleState} from "@models/draftPeople";

// Type-safe initialState!
export const initialState: DraftPeopleState = {
    data: [],
    errors: undefined,
    loading: false,
    count: 0
};

const reducer: Reducer<DraftPeopleState> = (state = initialState, action) => {
    switch (action.type) {
        case DraftsPeopleActionTypes.FETCH_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }

        case DraftsPeopleActionTypes.FETCH_SUCCESS: {
            const {data, meta} = action.payload;
            return {
                ...state,
                data,
                loading: false,
                count: meta.total_count,
                is_fetched: true
            }
        }

        case DraftsPeopleActionTypes.FETCH_ERROR: {
            return {...state, loading: false, errors: action.payload.error}
        }

        case DraftsPeopleActionTypes.UPDATE_SUCCESS: {
            const draftPeople = action.payload;
            return {
                ...state,
                data: state.data.map(item => (item.id == draftPeople.id) ? {
                    ...item,
                    ...draftPeople
                } : item),
            }
        }

        default: {
            return state
        }
    }
};

export {reducer as draftsPeopleReducer}
